<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','overflow': 'hidden'}">
        <img :src="loginBg">
        <div class="landing">
            <div class="title1">环保管家智慧平台</div>
            <div class="title2">您身边的环保管家</div>
            <div class="form" style="margin-top:30px">
                <input v-model="username" type="text" placeholder="用户名" autocapitalize="off" autocorrect="off">
                <input v-model="password" type="password" placeholder="密码" style="margin-top:20px" autocorrect="off">
                <div class="code-box" style="margin-top:20px">
                    <input v-model="vrifyCode" type="text" placeholder="验证码" autocapitalize="off" autocorrect="off">
                    <div class="btn" @click="getImgCode"><img :src="imgCode" alt=""></div>
                </div>
                <div class="login-btn" @click="toLogin">登录</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Setting from '@/setting';
    import { Toast } from 'vant';
    import $ from '@/fly'

    export default {
        data () {
            return {
                clientHeight: window.screen.height,
                username: '', // 用户名
                password: '', // 密码
                vrifyCode: '', // 验证码
                uuid: '', // 随机码
                imgCode: '', // 图片验证码
                loginBg: require('../assets/loginBg.png')
            }
        },
        created () {
            this.getImgCode()
        },
        methods: {
            ...mapActions('admin/account', [
                'login'
            ]),
            // 获取图形验证码
            getImgCode () {
                this.uuid = this.rand(1000, 9999);
                this.imgCode = `${Setting.apiBaseURL}kaptchaImage?uuid=${this.uuid}`;
            },
            // 登录
            toLogin () {
                let data = {}
                if (!this.username) {
                    Toast('请输入用户名');
                    return false;
                }
                if (!this.password) {
                    Toast('请输入密码');
                    return false;
                }
                if (!this.vrifyCode) {
                    Toast('请输入验证码');
                    return false;
                }
                data = {
                    username: this.username,
                    password: this.password,
                    vrifyCode: this.vrifyCode,
                    uuid: this.uuid,
                    wxopenid: localStorage.getItem('wxopenid')
                }
                this.login(data).then(async res => {
                    // 重定向对象不存在则返回顶层路径
                    /**
                    const roleName = res.roles[0]
                    switch (roleName) {
                    case '咨询顾问':
                        this.$router.replace({ name: 'homepage', params: { roleName: roleName } });
                        break;
                    case '项目负责人':
                        this.$router.replace({ name: 'homepage', params: { roleName: roleName } });
                        break;
                    default:
                        Toast('未授权访问角色');
                        break;
                    } */
                    /** const _problemTypeDict = await $.get('dict/getDictByType/problemType')
                    const _problemLevelDict = await $.get('dict/getDictByType/problemLevel')
                    sessionStorage.setItem('problemTypeDict', JSON.stringify(_problemTypeDict))
                    sessionStorage.setItem('problemLevelDict', JSON.stringify(_problemLevelDict)) */
                  if (res.roles.indexOf('一级管理员') >= 0 || res.roles.indexOf('三级管理员') >= 0 || res.roles.indexOf('二级管理员') >= 0 || res.roles.indexOf('管理员') >= 0)
                        await this.$router.replace({ name: 'homepage' })
                }).catch((msg) => {
                    this.getImgCode()
                })
            }
        }
    }
</script>

<style lang="less">

.landing {
        padding: 40px;
        width: 100%;
        position: fixed;
        top: 60px;
        .title1,.title2{
          text-align: center;
          color: #FFFFFF;
        }
        .title1{
          font-weight: 800;
          font-size: 36px;
          line-height: 100px;
        }
        .title2{
          font-weight: 500;
          font-size: 28px;
          line-height: 60px;
        }
        .form{
          padding: 100px 40px;
          background-color: #FFFFFF;
          margin-top: 20px;
          border-radius: 5px;
        }
        input {
            display: block;
            margin-bottom: 0.32rem;
            width: 100%;
            height: 1.12rem;
            background: #f5f6f7;
            border: none;
            border-radius: 0.093rem;
            text-indent: 0.267rem;
            font-size: 0.373rem;
            color: #303234;
            @media (min-width: 768px) {
                margin-bottom: 0.2rem;
                height: 1rem;
            }
        }
        .code-box {
            background-color: #f5f6f7;
            input {
                display: inline-block;
                margin-bottom: 0;
                margin-right: 1%;
                width: 75%;
            }
            .btn {
                display: inline-block;
                width: 23%;
                line-height: 50px;
                border-radius: 10px;
                border: 1PX solid #bbb;
                background-color: #fff;
                font-size: 20px;
                text-align: center;
            }
        }
        .login-btn {
            margin-top: 1.333rem;
            display: block;
            width: 100%;
            height: 1.12rem;
            line-height: 1.12rem;
            border: none;
            background: #1B75F6;
            border-radius: 0.093rem;
            box-shadow: 0px 4px 24px 0px rgba(84, 195, 253, 0.153);
            font-size: 0.48rem;
            color: #fff;
            text-align: center;
            @media (min-width: 768px) {
                margin-top: 0.8rem;
                height: 1rem;
            }
        }
        @media (min-width: 768px) {
            padding: 48PX 64PX;
            div {
                font-size: 25.6PX;
                line-height: 54PX;
            }
            input {
                margin-bottom: 12PX;
                height: 60PX;
                border-radius: 5.6PX;
                text-indent: 16PX;
                font-size: 22.5PX;
            }
            .login-btn {
                margin-top: 48PX;
                height: 60PX;
                line-height: 60PX;
                border-radius: 5.6PX;
                box-shadow: 0px 4px 24px 0px rgba(84, 195, 253, 0.153);
                font-size: 25.6PX;
            }
        }
    }
    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }
</style>
